









import { defineComponent } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';

const name = 'ttam-optimization-goal-explanation-hint';

export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    tips: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      name,
    };
  },
});
